import {createStore} from 'vuex'
import {ethers} from "ethers";
import {ChainId} from "@uniswap/sdk-core";
import axios from "@/utils/axios";

export const launchpad_address = "0xa4d25bF0c497890Ef1102762Cf896C9Af6D421C8";
export const uni_router_address = "0x10ED43C718714eb63d5aA57B78B54704E256024E";
export const uni_factory_address = "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73"
export const weth_address = "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"

export default createStore({
    state: {
        wallet_address: "",
        signger: null,
        wallet_type: null,
    },
    getters: {},
    mutations: {
        SET_WALLET_ADDRESS(state, address) {
            state.wallet_address = address
        },
        SET_SIGNER(state, signer) {
            state.signger = signer
        },
        SET_WALLET_TYPE(state, wallet_type) {
            state.wallet_type = wallet_type
        }
    },
    actions: {
        async connect_wallet({commit}, wallet_type) {

            console.log("wallet_type", wallet_type)

            let provider;
            let signer;
            let address;

            switch (wallet_type) {
                case 'metamask':
                    if (window.ethereum && window.ethereum.isMetaMask) {
                        provider = new ethers.BrowserProvider(window.ethereum);
                        // 请求用户连接钱包
                        await window.ethereum.request({method: 'eth_requestAccounts'});
                    } else {
                        // 弹出新窗口到 MetaMask 官网
                        window.open('https://metamask.io/', '_blank');
                        console.error('MetaMask is not installed!');
                    }
                    break;
                case 'okx':
                    if (window.okxwallet) {
                        provider = new ethers.BrowserProvider(window.okxwallet);
                        await window.okxwallet.request({method: 'eth_requestAccounts'});
                    } else {
                        // 弹出新窗口到 OKX 官网
                        window.open('https://www.okx.com/', '_blank');
                        console.error('OKX Wallet is not installed!');
                    }
                    break;
                case 'gate':
                    if (window.gatewallet) {
                        provider = new ethers.BrowserProvider(window.gatewallet);
                        await window.gatewallet.request({method: 'eth_requestAccounts'});
                    } else {
                        // 弹出新窗口到 Gate Wallet 官网
                        window.open('https://www.gate.io/', '_blank');
                        console.error('Gate Wallet is not installed!');
                    }
                    break;
                default:
                    console.error('Unsupported wallet type!');
                    break;
            }

            if (provider) {
                const chainId = ChainId.BNB; // BSC mainnet chain ID
                await provider.send('wallet_switchEthereumChain', [{chainId: '0x38'}]);
            }
            if (provider) {
                const accounts = await provider.send("eth_requestAccounts", []);
                signer = await provider.getSigner();
                console.log('signer', signer)
                address = accounts[0];
                console.log('accounts', accounts);

                //保存 address 到 state的 wallet_address
                commit('SET_WALLET_ADDRESS', address)

                //保存 signer 到 state的 signger
                commit('SET_SIGNER', signer)

                commit('SET_WALLET_TYPE', wallet_type)


                const invitor = localStorage.getItem("invitor")
                // if (invitor) {
                console.log("invitor", invitor)
                await axios.post('/api/create_user', {
                    wallet: address,
                    invitor: invitor
                })


            }
        },
        disconnect() {
            this.commit('SET_WALLET_ADDRESS', "")
            this.commit('SET_SIGNER', null)
            this.commit('SET_WALLET_TYPE', null)
        }
    },
    modules: {}
})
